import { MouseEvent } from 'react';

/**
 * Обработчик клика по ссылке в содержании
 * Необходимо для плавного и точного перехода к содержанию
 * @param event - событие
 * @param id - аттрибут id элемента
 * @param offset - расстояние от верхней границы страницы до элемента
 */
export function handleNavigationClick(event: MouseEvent, id: string, offset: number = -100) {
    event.preventDefault();
    const targetElement = document.getElementById(id);
    if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition + offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }
}